import { createSlice } from '@reduxjs/toolkit';

import { handleGetAdminDrugClasses } from './actions';
import { IAdminDrugClassesState } from './slice.interface';

const initialState: IAdminDrugClassesState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const adminDrugClassesSlice = createSlice({
  name: 'admin-drug-classes',
  initialState,
  reducers: {
    removeAdminDrugClasses: (state: IAdminDrugClassesState) => {
      state.data = [];
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetAdminDrugClasses.pending, (state: IAdminDrugClassesState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetAdminDrugClasses.rejected, (state: IAdminDrugClassesState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetAdminDrugClasses.fulfilled, (state: IAdminDrugClassesState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export const { removeAdminDrugClasses } = adminDrugClassesSlice.actions;

export default adminDrugClassesSlice.reducer;
